/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface V1SearchAutoCompleteResultKeyword
 */
export interface V1SearchAutoCompleteResultKeyword {
    /**
     * 
     * @type {string}
     * @memberof V1SearchAutoCompleteResultKeyword
     */
    name: string;
}

/**
 * Check if a given object implements the V1SearchAutoCompleteResultKeyword interface.
 */
export function instanceOfV1SearchAutoCompleteResultKeyword(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function V1SearchAutoCompleteResultKeywordFromJSON(json: any): V1SearchAutoCompleteResultKeyword {
    return V1SearchAutoCompleteResultKeywordFromJSONTyped(json, false);
}

export function V1SearchAutoCompleteResultKeywordFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1SearchAutoCompleteResultKeyword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function V1SearchAutoCompleteResultKeywordToJSON(value?: V1SearchAutoCompleteResultKeyword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

